import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom"; // Use useHistory for v5
const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

const VerifyEmail = () => {
  console.log("newversion2.0?")
  const location = useLocation();
  const history = useHistory(); // For v5 navigation
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [timer, setTimer] = useState(5); // Timer set to 5 seconds

  // Helper function to parse query parameters
  const getQueryParams = () => {
    console.log("added a log");
    const params = new URLSearchParams(location.search);
    return {
      token: params.get("token"),
      email: params.get("email"),
      app_name: params.get("app_name", null),
      region: params.get("region", null),
      redirect: params.get("redirect") !== "false", // Default to true unless set to "false"
    };
  };

  const { token, email, redirect, app_name, region } = getQueryParams();
  useEffect(() => {
    if (token && email) {
      // Construct the API URL
      const apiUrl = app_name && region ? `https://${region}.userauth2.${backend_api_base_url}/verify_email?email=${email}&token=${token}&app_name=${app_name}` : `https://auth2.${backend_api_base_url}/verify_email?email=${email}&token=${token}`;

      // Fetch data from the API
      fetch(apiUrl)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          setResponse(data);
        })
        .catch((err) => {
          setError(err.message);
        });
    }
  }, [token, email, app_name, region]);

  useEffect(() => {
    if (response) {
      // Start countdown timer if verification is successful
      const intervalId = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(intervalId);
            if (redirect) {
              history.push("/login"); // Redirect to login after timer reaches 0
            }
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000); // 1 second interval

      return () => {
        clearInterval(intervalId); // Cleanup interval on unmount
      };
    }
  }, [response, history, redirect]);

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
        marginTop: "50px",
      }}
    >
      <h1>Email Verification</h1>
      {response && (
        <div>
          <h3>Verification Successful</h3>
          <div style={circleStyle}>
            <svg
              width="100"
              height="100"
              viewBox="0 0 100 100"
              style={{ transform: "rotate(-90deg)" }}
            >
              <circle
                cx="50"
                cy="50"
                r="45"
                stroke="#ddd"
                strokeWidth="5"
                fill="none"
              />
              <circle
                cx="50"
                cy="50"
                r="45"
                stroke="green"
                strokeWidth="5"
                fill="none"
                strokeDasharray={`${2 * Math.PI * 45}`}
                strokeDashoffset={`${2 * Math.PI * 45 * (timer / 5)}`}
                style={{
                  transition: "stroke-dashoffset 1s linear",
                }}
              />
            </svg>
            <p style={{ fontSize: "24px", fontWeight: "bold" }}>{timer}s</p>
          </div>
        </div>
      )}
      {error && (
        <div>
          <h3>Error</h3>
          <p style={{ color: "red" }}>{error}</p>
        </div>
      )}
      {!response && !error && <p>Loading...</p>}
    </div>
  );
};

// Style for the circular timer
const circleStyle = {
  display: "inline-block",
  position: "relative",
  width: "100px",
  height: "100px",
  marginTop: "20px",
  borderRadius: "50%",
  backgroundColor: "#f0f0f0",
  padding: "10px",
};

export default VerifyEmail;
